<ae-nav *ngIf="fullView"></ae-nav>
<div *ngIf="showHeader && stockItemId" class="container-fluid record-header">
  <mat-card appearance="outlined">
    <div class="center-title">
      <mat-card-header>
        <mat-card-title>
          StockItem FeaturePrint: {{ stockItem?.externalIdentifier }}
        </mat-card-title>
      </mat-card-header>
    </div>
  </mat-card>
</div>

<div class="container-fluid" *ngIf="stockItemId">
  <div class="row row-padded">
    <div class="col-md-6">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let facet of facets" [expanded]="facet.facetId === selectedFacet" (selectionchange)="selectedFacet = facet.facetId" >
          <mat-expansion-panel-header>{{facet.facetName}} - {{facet.status}}</mat-expansion-panel-header>
          <ae-facet [facetInput]="{facet: facet!, dataset: dataset!}"></ae-facet>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="col-md-6">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Stock Item Details</mat-expansion-panel-header>
          <default-stock-item *ngIf="customerName !== 'heraeus' && customerName !='richemont'" [stockItem]="stockItem"></default-stock-item>
          <heraeus-stock-item *ngIf="customerName === 'heraeus'" [stockItem]="stockItem"></heraeus-stock-item>
          <richemont-stock-item *ngIf="customerName === 'richemont'" [stockItem]="stockItem"></richemont-stock-item>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="stockItemHistory && stockItemHistory.length > 0" class="col-md-12" class="si-history">
      <mat-expansion-panel class="spacer" [expanded]="false">
        <mat-expansion-panel-header><h3>Stock Item Operation History</h3></mat-expansion-panel-header>
        <ae-stock-item-history [setHistory]="stockItemHistory" [dataset]="dataset" [stockItemId]="stockItemId"></ae-stock-item-history>
      </mat-expansion-panel>
    </div>
  </div>
</div>
<div class=container-fluid *ngIf="!stockItemId">
  <mat-card appearance="outlined">
    <mat-card-content>
      Missing
    </mat-card-content>
  </mat-card>
</div>
